import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class EmployeesNumbersService {
    constructor(private http:Http) {
    }

    private employeesNumbers: Array<any>;

    getEmployeesNumbers(): Observable<Array<any>> {
        if (isEmpty(this.employeesNumbers)) {
            return this.http.get('/api/client/dictionary/employees_numbers')
                .map(response => response.json())
                .map(response => {
                    this.employeesNumbers = response.employeesNumbers;
                    return this.employeesNumbers;
                });
        } else {
            return Observable.of(this.employeesNumbers);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/employees.numbers.service.ts